<template>
	<Dialog
		v-model:visible="$store.state.centers.dialog"
		:breakpoints="{ '960px': '75vw', '640px': '90vw' }"
		:style="{ width: '30vw' }"
		:modal="dialogDefaults.modal"
		:closeOnEscape="dialogDefaults.closeOnEscape"
		:dismissableMask="dialogDefaults.dismissableMask"
		@hide="hide"
		@show="show"
	>
		<template #header>
			<FormTitle :title="title" />
		</template>

		<form @keydown="$event.key === 'Enter' ? save() : null">
			<div class="row gy-3 pt-3">
				<div class="col-12">
					<InputText
						ref="nombre"
						label="Nombre"
						:disabled="disabled"
						:error="form.errors.get('nombre')"
						@change-value="(value) => (form.nombre = value)"
					/>
				</div>
				<div class="col-12">
					<InputText
						ref="direccion"
						label="Dirección"
						:disabled="disabled"
						:error="form.errors.get('direccion')"
						@change-value="(value) => (form.direccion = value)"
					/>
				</div>
				<div class="col-12">
					<InputText
						ref="telefono"
						label="Teléfono"
						:disabled="disabled"
						:error="form.errors.get('telefono')"
						@change-value="(value) => (form.telefono = value)"
					/>
				</div>
				<div class="col-12">
					<InputText
						ref="email"
						label="Email"
						:disabled="disabled"
						:error="form.errors.get('email')"
						@change-value="(value) => (form.email = value)"
					/>
				</div>
				<div class="col-12">
					<CheckBox
						ref="status_chat"
						label="Permitir hablar a los padres con el monitor"
						:disabled="disabled"
						:error="form.errors.get('status_chat')"
						@change-value="(value) => (form.status_chat = value)"
						:binary="true"
					/>
				</div>
			</div>
		</form>

		<template #footer v-if="!disabled">
			<div class="col-12 d-flex justify-content-between">
				<Button
					@click="
						toggleFormDialog({
							stateVariable: stateVariable,
							show: false,
						})
					"
					label="Cancelar"
					:disabled="form.busy"
					class="bg-white border border-primary text-primary"
				/>
				<Button @click="save()" label="Guardar" :disabled="form.busy" />
			</div>
		</template>
	</Dialog>
</template>

<script>
	import Form from "vform";
	import { mapActions, mapMutations, mapState } from "vuex";

	export default {
		props: {
			route: {
				type: String,
				required: true,
			},
			stateVariable: {
				type: String,
				required: true,
			},
		},
		data: () => ({
			form: new Form(),
			modelName: "centro",
			title: `Añadir centro`,
			disabled: false,
			lastPageChange: null,
		}),
		methods: {
			...mapActions(["sendForm", "getRegisters"]),
			...mapMutations(["toggleFormDialog", "changeCurrentRegister"]),
			save() {
				const update = this.centers.register != null;
				const url = `/centers${
					update ? `/${this.centers.register.id_centro}` : ""
				}`;

				this.sendForm({
					method: update ? "put" : "post",
					form: this.form,
					url: url,
					errors: this.form.errors,
				}).then((response) => {
					if (response.status === 200) {
						this.toggleFormDialog({
							stateVariable: this.stateVariable,
							show: false,
						});

						this.getRegisters({
							route: this.route,
							stateVariable: this.stateVariable,
							page: this.centers.currentPage,
							rows: this.centers.rows,
						});
					}
				});
			},
			hide() {
				this.title = `Añadir ${this.modelName}`;
				this.disabled = false;

				this.changeCurrentRegister({
					stateVariable: this.stateVariable,
					register: null,
				});
			},
			clearForm() {
				this.form.clear();
				this.form.reset();

				for (const key in this.$refs) {
					if (Object.hasOwnProperty.call(this.$refs, key)) {
						this.$refs[key].model = null;
					}
				}

				this.$refs.status_chat.model = false;
			},
			show() {
				this.clearForm();

				const register = this.centers.register;

				if (register != null) {
					for (const key in register) {
						if (
							Object.hasOwnProperty.call(register, key) &&
							this.$refs[key] != undefined
						) {
							this.$refs[key].model = register[key];
						}
					}

					this.$refs.status_chat.model = register.status_chat ? true : false;

					if (this.centers.dialogMode == "edit") {
						this.title = `Editar ${this.modelName}`;
						this.disabled = false;
					} else {
						this.title = `Ver ${this.modelName}`;
						this.disabled = true;
					}
				}
			},
		},
		computed: {
			...mapState(["dialogDefaults", "centers"]),
		},
	};
</script>
